import {
  GET_HANDOVERLIST,
  GET_HANDOVERLIST_SUCCESS,
  GET_HANDOVERLIST_FAIL,
  DELETE_HANDOVERLIST,
  DELETE_HANDOVERLIST_SUCCESS,
  DELETE_HANDOVERLIST_FAIL,
  UPDATE_HANDOVERLIST,
  UPDATE_HANDOVERLIST_SUCCESS,
  UPDATE_HANDOVERLIST_FAIL,
  ADD_NEW_HANDOVERLIST,
  ADD_HANDOVERLIST_SUCCESS,
  ADD_HANDOVERLIST_FAIL,
  HANDOVERLIST_LOADING,
  HANDOVERLIST_RESET
} from "./actionType";

export const resetHandoverListState = (actionType) => ({
  type: HANDOVERLIST_RESET,
  payload: { actionType },
});

export const getHandoverListSuccess = (actionType, data) => ({
  type: GET_HANDOVERLIST_SUCCESS,
  payload: { actionType, data },
});

export const getHandoverListFail = (actionType, error) => ({
  type: GET_HANDOVERLIST_FAIL,
  payload: { actionType, error },
});

export const getHandoverList = data => ({
  type: GET_HANDOVERLIST,
  payload: data,
});

export const getHandoverListLoading = () => ({
  type: HANDOVERLIST_LOADING
});

export const deleteHandoverList = data => ({
  type: DELETE_HANDOVERLIST,
  payload: data,
});

export const deleteHandoverListSuccess = data => ({
  type: DELETE_HANDOVERLIST_SUCCESS,
  payload: data,
});

export const deleteHandoverListFail = error => ({
  type: DELETE_HANDOVERLIST_FAIL,
  payload: error,
});

export const updateHandoverList = data => ({
  type: UPDATE_HANDOVERLIST,
  payload: data,
});

export const updateHandoverListFail = error => ({
  type: UPDATE_HANDOVERLIST_FAIL,
  payload: error,
});

export const updateHandoverListSuccess = data => ({
  type: UPDATE_HANDOVERLIST_SUCCESS,
  payload: data,
});

export const addNewHandoverList = data => ({
  type: ADD_NEW_HANDOVERLIST,
  payload: data,
});

export const addHandoverListSuccess = data => ({
  type: ADD_HANDOVERLIST_SUCCESS,
  payload: data,
});

export const addHandoverListFail = error => ({
  type: ADD_HANDOVERLIST_FAIL,
  payload: error,
});